module.exports = __webpack_public_path__ + "static/media/hive.d514c11b.webm";